import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=facbada4&scoped=true&"
import script from "./bar.vue?vue&type=script&lang=js&"
export * from "./bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facbada4",
  null
  
)

export default component.exports